import pagePermissions from '../pagePermissions.json';

export const hasPermission = (userId: number, sectionName: string): boolean => {
  const sectionKey = sectionName.toLowerCase();
  const allowedUsers =
    pagePermissions[sectionKey as keyof typeof pagePermissions];
  return allowedUsers.includes(userId);
};
